/** Volatile browser session only. Never bundled credentials, storage, query parameters or cookies. */
let credential: string | null = null;
export function setMonitoringWriteSession(value: string | null): void {
  if (value !== null && !/^[A-Za-z0-9_-]{32,256}$/.test(value))
    throw new Error('监测写入会话格式无效');
  credential = value;
}
export function monitoringWriteSession(): string | null {
  return credential;
}
